import { jsxs as e, jsx as r } from "react/jsx-runtime";
import F from "react";
import { BreadCrumb as H } from "../BreadCrumb/BreadCrumb.js";
import W from "../Footer/Footer.js";
import j from "../Header/Header.js";
import d from "../Icons/Spinner.js";
import { Layout as P } from "../Layout/Layout.js";
import { Title as T } from "../Title/Title.js";
import { VisuallyHidden as _ } from "../VisuallyHidden/VisuallyHidden.js";
import { i as v } from "../../helpers-CNa1KUVl.mjs";
import { Wrapper as J, Content as s, LoadingSpinner as c, ChildrenWrapper as M } from "./styled.js";
const O = ({
  title: i,
  loading: o = !1,
  showHeader: h = !0,
  showBreadCrumb: p = !0,
  showFooter: a = !1,
  showSiteFurnitureInApp: l = !1,
  contentPadding: f = 32,
  imgUrl: u,
  breadCrumbs: w = [],
  loadingContent: t,
  StaticContent: b,
  opacityBetweenLoading: L = 0,
  error: m,
  headerProps: $ = {},
  backgroundColor: g = "",
  mainBackgroundColor: y = "",
  backgroundColorBannerPrimary: C = "",
  backgroundColorBannerSecondary: k = "",
  children: x,
  homeLink: S
}) => {
  const n = l ? !0 : !v(), B = /* @__PURE__ */ r(s, { role: "main", $showLoading: !0, children: /* @__PURE__ */ e(c, { $showLoading: !0, children: [
    /* @__PURE__ */ r(d, {}),
    t
  ] }) });
  return /* @__PURE__ */ e(J, { children: [
    /* @__PURE__ */ r(_, { children: /* @__PURE__ */ r("a", { href: "#content", children: "Jump to main content" }) }),
    /* @__PURE__ */ r(j, { showHeader: h && n, ...$ }),
    /* @__PURE__ */ r(
      H,
      {
        showBreadCrumb: p && n,
        items: w,
        noBorder: !i,
        homeLink: S
      }
    ),
    /* @__PURE__ */ r("a", { id: "content" }),
    i && /* @__PURE__ */ r(
      T,
      {
        text: i,
        imgUrl: u,
        backgroundColorPrimary: C,
        backgroundColorSecondary: k
      }
    ),
    /* @__PURE__ */ e(
      P,
      {
        contentPadding: f,
        showLoading: o,
        showFooter: a,
        backgroundColor: g,
        mainBackgroundColor: y,
        hasTitle: !!i,
        children: [
          m,
          b,
          /* @__PURE__ */ r(F.Suspense, { fallback: B, children: /* @__PURE__ */ e(s, { role: "main", $showLoading: o, children: [
            /* @__PURE__ */ e(c, { $showLoading: o, children: [
              /* @__PURE__ */ r(d, {}),
              t
            ] }),
            /* @__PURE__ */ r(
              M,
              {
                $opacity: L,
                $hide: o || !!m,
                $showLoading: o,
                children: x
              }
            )
          ] }) })
        ]
      }
    ),
    /* @__PURE__ */ r(W, { showFooter: a && n })
  ] });
};
export {
  O as Page,
  O as default
};
